// /components/Style/GBUIStyle.js

// ルートの Box（全体の余白）
export const GBUI_ROOT_BOX_SX = {
    m: 1,
    p: 4,
};

// Container（本体全体を囲う）
export const GBUI_CONTAINER_SX = {
    width: '500px',
};

// 本体外枠（赤いゲームボーイ本体）
export const GBUI_BODY_BOX_SX = {
    flexGrow: 1,
    bgcolor: '#C83031',
    borderRadius: '15px',
    height: '700px',
    width: '410px',
    position: 'relative', // 相対位置指定
};

// 画面外枠（黒い枠の部分）
export const GBUI_SCREEN_PAPER_SX = {
    m: 1,
    p: 1,
    borderRadius: '13px',
    height: '330px',
    width: '350px',
    bgcolor: '#222222',
    position: 'absolute', // 絶対位置指定
    top: '20px',
    left: '15px',
};

// POWERランプ部分（● ) ) )）
export const GBUI_POWER_DOT_TEXT_SX = {
    fontFamily: 'Meiryo',
    fontStyle: 'italic',
    fontSize: '9px',
    bgcolor: 'transparent',
    color: 'white',
    position: 'absolute',
    top: '60px',
    left: '10px',
};

// POWER文字ラベル
export const GBUI_POWER_LABEL_TEXT_SX = {
    fontFamily: 'Meiryo',
    fontStyle: 'italic',
    fontSize: '9px',
    bgcolor: 'transparent',
    color: 'white',
    position: 'absolute',
    top: '80px',
    left: '10px',
};

// GAME BOY ロゴ
export const GBUI_GAMEBOY_LOGO_TEXT_SX = {
    fontFamily: 'Meiryo',
    fontStyle: 'italic',
    fontWeight: 'bold',
    fontSize: '24px',
    bgcolor: 'transparent',
    color: 'white',
    position: 'absolute',
    top: '305px',
    left: '70px',
};

// COLOR ロゴ
export const GBUI_COLOR_LOGO_TEXT_SX = {
    fontFamily: 'Kalam',
    fontStyle: 'italic',
    fontWeight: 'bold',
    fontSize: '24px',
    bgcolor: 'transparent',
    color: 'white',
    position: 'absolute',
    top: '305px',
    left: '220px',
};

// Nintendo ロゴ
export const GBUI_NINTENDO_LOGO_TEXT_SX = {
    fontStyle: 'italic',
    fontWeight: 'bold',
    fontSize: '15px',
    bgcolor: 'transparent',
    color: '#696969',
    position: 'absolute',
    top: '390px',
    left: '160px',
    border: '2px solid #696969',
    borderRadius: '15px',
    padding: '0 10px',
};
